module.exports = __webpack_public_path__ + "static/media/home_01.adb907af.jpg";